import {
  TaxDTO,
  TaxSpecificationResponseDTO,
  GSTDeterminationResponseDTO,
  GSTDeterminationDetailsDTO,
  TDSRateDTO,
  TDSRatesResponseDTO,
} from "../models/TaxDTOs";
import {
  TaxEntity,
  TaxSpecificationResultEntity,
  GSTDeterminationEntity,
  GSTDeterminationDetailsEntity,
  TDSRateEntity,
  TDSRatesResultEntity,
} from "../../domain/entities/TaxEntity";

export class TaxMapper {
  static toTaxEntity(dto: TaxDTO): TaxEntity {
    return {
      tax_id: dto.tax_id,
      tax_name: dto.tax_name,
      tax_percentage: dto.tax_percentage,
      tax_type: dto.tax_type,
      tax_specific_type: dto.tax_specific_type,
      tax_authority_id: dto.tax_authority_id,
      tax_authority_name: dto.tax_authority_name,
      output_tax_account_name: dto.output_tax_account_name,
      tax_account_id: dto.tax_account_id,
      is_inactive: dto.is_inactive,
      is_default_tax: dto.is_default_tax,
      is_editable: dto.is_editable,
      tax_specification: dto.tax_specification,
      diff_rate_reason: dto.diff_rate_reason,
      start_date: dto.start_date,
      end_date: dto.end_date,
      last_modified_time: dto.last_modified_time,
      status: dto.status,
      created_at: dto.created_at,
      updated_at: dto.updated_at,
    };
  }

  static toTaxSpecificationResultEntity(
    dto: TaxSpecificationResponseDTO
  ): TaxSpecificationResultEntity {
    return {
      success: dto.success,
      data: {
        taxes: dto.data.taxes.map((tax) => this.toTaxEntity(tax)),
        specification: dto.data.specification,
        pagination: dto.data.pagination,
      },
    };
  }

  static toGSTDeterminationDetailsEntity(
    dto: GSTDeterminationDetailsDTO
  ): GSTDeterminationDetailsEntity {
    return {
      source_state: dto.source_state,
      destination_state: dto.destination_state,
      source_state_normalized: dto.source_state_normalized,
      destination_state_normalized: dto.destination_state_normalized,
      is_inter_state: dto.is_inter_state,
      validation_note: dto.validation_note,
      tax_specification: dto.tax_specification,
    };
  }

  static toGSTDeterminationEntity(
    dto: GSTDeterminationResponseDTO
  ): GSTDeterminationEntity {
    return {
      success: dto.success,
      tax_type: dto.tax_type,
      gst_type: dto.gst_type,
      supply_type: dto.supply_type,
      details: this.toGSTDeterminationDetailsEntity(dto.details),
      timestamp: dto.timestamp,
      request_id: dto.request_id,
    };
  }

  static toTDSRateEntity(dto: TDSRateDTO): TDSRateEntity {
    return {
      id: dto.id,
      tds_tax_id: dto.tds_tax_id,
      tds_tax_name: dto.tds_tax_name,
      tds_tax_percentage: dto.tds_tax_percentage,
      tds_tax_type: dto.tds_tax_type,
      business_display: dto.business_display,
      individual_display: dto.individual_display,
      is_expired: dto.is_expired ?? true,
    };
  }

  static toTDSRatesResultEntity(dto: TDSRatesResponseDTO): TDSRatesResultEntity {
    return {
      success: dto.success,
      message: dto.message,
      data: {
        tds_rates: dto.data.tds_rates.map((rate) => this.toTDSRateEntity(rate)),
        total_count: dto.data.total_count,
      },
    };
  }

  static toTaxDTO(entity: TaxEntity): TaxDTO {
    return {
      tax_id: entity.tax_id,
      tax_name: entity.tax_name,
      tax_percentage: entity.tax_percentage,
      tax_type: entity.tax_type,
      tax_specific_type: entity.tax_specific_type,
      tax_authority_id: entity.tax_authority_id,
      tax_authority_name: entity.tax_authority_name,
      output_tax_account_name: entity.output_tax_account_name,
      tax_account_id: entity.tax_account_id,
      is_inactive: entity.is_inactive,
      is_default_tax: entity.is_default_tax,
      is_editable: entity.is_editable,
      tax_specification: entity.tax_specification,
      diff_rate_reason: entity.diff_rate_reason,
      start_date: entity.start_date,
      end_date: entity.end_date,
      last_modified_time: entity.last_modified_time,
      status: entity.status,
      created_at: entity.created_at,
      updated_at: entity.updated_at,
    };
  }
}

